import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InteractionCustomComponent } from './interaction-custom.component';


const routes: Routes = [
  {
    path: ':type/:slug',
    component: InteractionCustomComponent
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InteractionCustomRoutingModule { }
